/* eslint-disable no-shadow */
/* eslint-disable no-param-reassign */
import * as types from "./types";

export const state = {
  filtersTypeName: "",
  ordination: "",
  filtersOrdination: "",
  filtersTransactionType: "",
  notificationBar: false,
  all: [],
  received: [],
  sended: [],
  filtersId: "",
  filtersPositive: "",
  filtersTypeId: "",
  filtersKind: "",
  filtersAmount: "",
  filtersInitialDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().split('T')[0] + ' 00:00:00',
  filtersFinalDate: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().split('T')[0] + ' 23:59:59',
  filtersStatus: "",
  filtersPayerName: "",

  limitOptions: [50, 75, 100],
  totalResources: 0,
  currentPage: 1,
  limit: 10,
  loadingData: true,
  showFilters: false,
  filterParams: {
    page: 1,
    limit: 10,
    filterrific: {
      with_created_at_between: {
        start_at: "",
        end_at: ""
      },
      sorted_by: "",
      with_type_name: ""
    }
  },
  bill: {},
  billErrors: {
    messages: [
      {
        status: "",
        name: "",
        date: "",
        errors: [{ code: "", message: "" }]
      }
    ],
    error: "",
    errors: "",
    mensagem: "",
    desenvolvedor: {
      mensagem: ""
    }
  },
  billPayment: {},
  showBillPayment: {},
  showBillPayments: {},
  billPaymentError: {
    status: 0,
    mensagem: "",
  },
  billsResources: {
    resources: [],
    loadingData: false,
    resourcesCount: 0,
    currentPage: 1,
    status: "",
    limitOptions: [50, 75, 100],
    limit: 25,
    ordination: "",
    filtersOrdination: "",
    filtersTypeName: "",
  },
  billsPaymentResources: {
    resources: [],
    loadingData: false,
    resourcesCount: 0,
    currentPage: 1,
    status: "",
    limitOptions: [50, 75, 100],
    limit: 25,
    ordination: "",
    filtersOrdination: "",
    filtersTypeName: "",
  },
  darfPayment: {},
  showDarfPayment: {},
  darfPaymentError: {
    status: 0,
    mensagem: "",
  },
  darfPaymentLoadingData: false,
  darfsPaymentResources: {
    resources: [],
    loadingData: false,
    resourcesCount: 0,
    currentPage: 1,
    status: "",
    limitOptions: [50, 75, 100],
    limit: 25,
    ordination: "",
    filtersOrdination: "",
    filtersTypeName: "",
  },
  // PIX Payment State
  pixPayment: {},
  showPixPayment: {},
  pixPaymentError: {},
  pixPaymentLoadingData: false,
  pixPaymentResources: {
    resources: [],
    loadingData: false,
    resourcesCount: 0,
    currentPage: 1,
    limit: 25
  }
};

export const mutations = {
  [types.SET_ALL](state, all) {
    state.all = all;
  },
  [types.SET_RECEIVEDS](state, received) {
    state.received = received;
  },
  [types.SET_SENDEDS](state, sended) {
    state.sended = sended;
  },
  [types.CURRENT_PAGE](state, page) {
    state.currentPage = page;
  },
  [types.SET_TOTAL_RESOURCES](state, total) {
    state.totalResources = total;
  },
  [types.LIMIT_OPTIONS](state, options) {
    state.limitOptions = options;
  },
  [types.LIMIT](state, limit) {
    state.limit = limit;
  },
  [types.LOADING_DATA](state, status) {
    state.loadingData = status;
  },
  [types.NOTIFICATION_BAR](state, param) {
    state.noificationBar = param;
  },
  [types.SHOW_FILTERS](state, param) {
    state.showFilters = param;
  },
  [types.FILTER_PARAMS](state, param) {
    state.filterParams = param;
  },
  [types.SET_URL_BILL](state, bill) {
    state.bill = bill;
  },
  [types.SET_BILL_ERROS](state, erros) {
    state.billErrors = erros;
  },
  [types.SET_BILL_PAYMENT](state, response) {
    state.billPayment = response;
  },
  [types.SHOW_BILL_PAYMENT](state, response) {
    state.showBillPayment = response;
  },
  [types.SHOW_BILL_PAYMENTS](state, response) {
    state.showBillPayments = response;
  },
  [types.SET_BILL_PAYMENT_ERRORS](state, response) {
    state.billPaymentError = response;
  },
  [types.SET_BILL_RESOURCES](state, resources) {
    state.billsResources.resources = resources;
  },
  [types.SET_BILL_RESOURCES_COUNT](state, count) {
    state.billsResources.resourcesCount = count;
  },
  [types.SET_BILL_LOADING_DATA](state, response) {
    state.billsResources.loadingData = response;
  },
  [types.SET_BILL_CURRENT_PAGE](state, response) {
    state.billsResources.currentPage = response;
  },
  [types.SET_BILL_LIMIT](state, response) {
    state.billsResources.limit = response;
  },
  [types.SET_BILL_PAYMENT_RESOURCES](state, resources) {
    state.billsPaymentResources.resources = resources;
  },
  [types.SET_BILL_PAYMENT_RESOURCES_COUNT](state, count) {
    state.billsPaymentResources.resourcesCount = count;
  },
  [types.SET_BILL_PAYMENT_LOADING_DATA](state, response) {
    state.billsPaymentResources.loadingData = response;
  },
  [types.SET_BILL_PAYMENT_CURRENT_PAGE](state, response) {
    state.billsPaymentResources.currentPage = response;
  },
  [types.SET_BILL_PAYMENT_LIMIT](state, response) {
    state.billsPaymentResources.limit = response;
  },
  [types.SET_FILTER_ID](state, id) {
    state.filtersId = id;
  },
  [types.SET_FILTER_TYPE_NAME](state, typeName) {
    state.filtersTypeName = typeName;
  },
  [types.SET_FILTER_POSITIVE](state, positive) {
    state.filtersPositive = positive;
  },
  [types.SET_FILTER_TYPE_ID](state, typeId) {
    state.filtersTypeId = typeId;
  },
  [types.SET_FILTER_KIND](state, kind) {
    state.filtersKind = kind;
  },
  [types.SET_FILTER_TYPE_AMOUNT](state, amount) {
    state.filtersAmount = amount;
  },
  [types.SET_FILTER_INITIAL_DATE](state, date) {
    state.filtersInitialDate = date;
  },
  [types.SET_FILTER_FINAL_DATE](state, date) {
    state.filtersFinalDate = date;
  },
  [types.FILTER_INITIAL_DATE](state, date) {
    state.initialDate = date;
  },
  [types.FILTER_FINAL_DATE](state, date) {
    state.finalDate = date;
  },
  [types.ORDINATION](state, value) {
    state.ordination = value;
  },
  [types.SET_FILTER_ORDINATION](state, ordination) {
    state.filtersOrdination = ordination;
  },
  [types.SET_FILTER_STATUS](state, status) {
    state.filtersStatus = status;
  },
  [types.SET_FILTER_PAYER_NAME](state, payerName) {
    state.filtersPayerName = payerName;
  },
  [types.SET_FILTER_AMOUNT](state, amount) {
    state.filtersAmount = amount;
  },
  // DARF Payment Mutations
  [types.SET_DARF_PAYMENT](state, response) {
    state.darfPayment = response;
  },
  [types.SHOW_DARF_PAYMENT](state, response) {
    state.showDarfPayment = response;
  },
  [types.SET_DARF_PAYMENT_ERRORS](state, response) {
    state.darfPaymentError = response;
  },
  [types.SET_DARF_PAYMENT_LOADING_DATA](state, response) {
    state.darfPaymentLoadingData = response;
  },
  [types.SET_DARFS_PAYMENT_RESOURCES](state, resources) {
    state.darfsPaymentResources.resources = resources;
  },
  [types.SET_DARFS_PAYMENT_RESOURCES_COUNT](state, count) {
    state.darfsPaymentResources.resourcesCount = count;
  },
  [types.SET_DARFS_PAYMENT_LOADING_DATA](state, response) {
    state.darfsPaymentResources.loadingData = response;
  },
  [types.SET_DARFS_PAYMENT_CURRENT_PAGE](state, response) {
    state.darfsPaymentResources.currentPage = response;
  },
  [types.SET_DARFS_PAYMENT_LIMIT](state, response) {
    state.darfsPaymentResources.limit = response;
  },
  // PIX Payment Mutations
  [types.SET_PIX_PAYMENT](state, response) {
    state.pixPayment = response;
  },
  [types.SHOW_PIX_PAYMENT](state, response) {
    state.showPixPayment = response;
  },
  [types.SET_PIX_PAYMENT_ERRORS](state, response) {
    state.pixPaymentError = response;
  },
  [types.SET_PIX_PAYMENT_LOADING_DATA](state, response) {
    state.pixPaymentLoadingData = response;
  },
  [types.SET_PIX_PAYMENT_RESOURCES](state, resources) {
    state.pixPaymentResources.resources = resources;
  },
  [types.SET_PIX_PAYMENT_RESOURCES_COUNT](state, count) {
    state.pixPaymentResources.resourcesCount = count;
  },
};
